// styles

import(/* webpackChunkName: "inpageFeedback" */ '../Styles/inpageFeedback.scss');

import(/* webpackChunkName: "errorPage" */ 'Feature/ErrorHandling/code/Styles/errorPage.scss');

import(/* webpackChunkName: "lotteryStage-footnote" */ 'Feature/LotteryContentElements/code/Styles/LotteryStage/lotteryStage-footnote.scss');

const { ifExist } = await import(/* webpackChunkName: "utility" */ 'Common/Scripts/Common/utility');

//  on-demand styles

if (ifExist('.nav-mobile-show')) import(/* webpackChunkName: "mobileNavigation" */ '../Styles/mobileNavigation.scss');

if (ifExist('[data-image-zoom]:not([data-image-zoom=""])')) import(/* webpackChunkName: "imageZoom" */ 'Foundation/ImageZoom/code/Scripts/imageZoom.js');

if (ifExist('.image-position')) import(/* webpackChunkName: "imagePosition" */ 'Feature/Common/code/ImagePosition/Styles/imagePosition.scss');

if (ifExist('.render-feedback-chat')) import(/* webpackChunkName: "feedback-widget" */ 'Feature/Common/code/Styles/feedback-widget.scss');

if (ifExist('.render-feedback-chat')) import(/* webpackChunkName: "webchat-widget" */ 'Feature/Common/code/Styles/webchat-widget.scss');

if (ifExist('.link-list')) import(/* webpackChunkName: "linklist" */ 'Foundation/ContentElements/code/Linklist/Styles/linklist.scss');

if (ifExist('.social-sharing-container')) import(/* webpackChunkName: "socialSharing" */ 'Feature/Common/code/Styles/socialSharing.scss');

if (ifExist('.switch')) import(/* webpackChunkName: "checkboxSlider" */ 'Feature/Common/code/Design/Styles/checkboxSlider.scss');

if (ifExist('.checklist')) import(/* webpackChunkName: "checklist" */ 'Feature/ContentElements/code/Styles/Checklist/checklist.scss');

if (ifExist('.sponsorship-examples-overview') || ifExist('.sponsorship-examples-project-detail-page')) import(/* webpackChunkName: "projectDetailPage" */ 'Feature/SponsorshipExamples/code/Styles/projectDetailPage.scss');

if (ifExist('.sponsorship-examples-project-detail-page')) import(/* webpackChunkName: "sponsorshipExamplesOverview" */ 'Feature/SponsorshipExamples/code/Styles/sponsorshipExamplesOverview.scss');

if (ifExist('.am-slider') || ifExist('.process-slider')) import(/* webpackChunkName: "pagination" */ 'Feature/Common/code/Pagination/Styles/pagination');

if (ifExist('.am-slider') || ifExist('.process-slider')) import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');

if (ifExist('.partner')) import(/* webpackChunkName: "partner" */ 'Feature/ContentElements/code/Styles/Partner/partner.scss');

if (ifExist('.quote')) import(/* webpackChunkName: "quote" */ 'Feature/ContentElements/code/Quote/Styles/quote.scss');

if (ifExist('.am-table')) import(/* webpackChunkName: "table" */ 'Feature/ContentElements/code/Styles/Table/table.scss');

if (ifExist('.news-details')) import(/* webpackChunkName: "newsdetails" */ 'Feature/ContentElements/code/Styles/News/newsdetails.scss');

if (ifExist('.checklist')) import(/* webpackChunkName: "checklist" */ 'Feature/ContentElements/code/Styles/Checklist/checklist.scss');

if (ifExist('.intro-text')) import(/* webpackChunkName: "introtext" */ 'Feature/ContentElements/code/Styles/IntroText/introtext.scss');

if (ifExist('.byline-container')) import(/* webpackChunkName: "byline" */ 'Feature/ContentElements/code/Styles/Byline/byline.scss');

if (ifExist('.question-summary')) import(/* webpackChunkName: "questionSummary" */ 'Feature/InclusionAutomat/code/Styles/questionSummary.scss');

if (ifExist('.faq-page')) import(/* webpackChunkName: "faqPage" */ 'Feature/ContentElements/code/Styles/Faq/faqPage.scss');

if (ifExist('.faq-overview')) import(/* webpackChunkName: "faqCategoryOverview" */ 'Feature/ContentElements/code/Styles/Faq/faqCategoryOverview.scss');

if (ifExist('.faq-accordion-question')) import(/* webpackChunkName: "faqQuestion" */ 'Feature/ContentElements/code/Styles/Faq/faqQuestion.scss');

if (ifExist('.html-element')) import(/* webpackChunkName: "htmlElement" */ 'Feature/ContentElements/code/HtmlElement/Styles/htmlElement.scss');

if (ifExist('.footnotes-container')) import(/* webpackChunkName: "footnotes" */ 'Feature/ContentElements/code/Styles/Footnotes/footnotes.scss');

if (ifExist('.instagram-module')) import(/* webpackChunkName: "instagramModule" */ 'Feature/ContentElements/code/Styles/InstagramModule/instagramModule.scss');

if (ifExist('.breadcrumb-navigation-container')) import(/* webpackChunkName: "breadcrumb" */ 'Feature/Navigation/code/Navigation/Styles/breadcrumb.scss');

if (ifExist('.faq-important-questions')) import(/* webpackChunkName: "faqImportantQuestions" */ 'Feature/ContentElements/code/Styles/Faq/faqImportantQuestions.scss');

if (ifExist('.footer-newsletter-teaser')) import(/* webpackChunkName: "newsletterteaser" */ 'Feature/Navigation/code/NewsletterTeaser/Styles/newsletterteaser.scss');

if (ifExist('.imageFloatingTextTeaser-container')) import(/* webpackChunkName: "imageFloatingText" */ 'Feature/ContentElements/code/Styles/TeaserImageText/imageFloatingText.scss');

if (ifExist('.sponsorship-examples-advanced-project-detail-page')) import(/* webpackChunkName: "advancedProjectDetailPage" */ 'Feature/SponsorshipExamples/code/Styles/advancedProjectDetailPage.scss');

if (ifExist('.videoNumbers-check-container')) import(/* webpackChunkName: "videoNumbersCheck" */ 'Feature/ContentElements/code/Styles/TeaserVideoNumbersCheck/videoNumbersCheck.scss');

if (ifExist('.icontextmodule')) import(/* webpackChunkName: "iconTextModuleSpecialRaffle" */ 'Feature/ContentElements/code/Styles/IconTextModuleSpecialRaffle/iconTextModuleSpecialRaffle.scss');

//  on-demand scripts

if (ifExist('[target=_lightbox]')) import(/* webpackChunkName: "lightbox" */ 'Feature/Lightbox/Code/Scripts/Lightbox/lightbox');

if (ifExist('[target=_explanation]')) import(/* webpackChunkName: "explanation" */ 'Feature/Lightbox/Code/Scripts/Lightbox/explanation');

if (ifExist('.tabs')) import(/* webpackChunkName: "tabs" */ 'Feature/ContentElements/code/Scripts/Tabs/tabs');

if (ifExist('.line-tabs')) import(/* webpackChunkName: "lineTabs" */ 'Feature/Common/code/Scripts/Common/lineTabs');

if (ifExist('.switch-tabs')) import(/* webpackChunkName: "switchTabs" */ 'Feature/Common/code/Scripts/Common/switchTabs');

if (ifExist('.faq-page')) import(/* webpackChunkName: "faqPage" */ 'Feature/ContentElements/code/Scripts/Faq/faqPage');

if (ifExist('.news-list')) import(/* webpackChunkName: "newslist" */ 'Feature/ContentElements/code/Scripts/News/newslist');

if (ifExist('.faq-module')) import(/* webpackChunkName: "faqModule" */ 'Feature/ContentElements/code/Scripts/Faq/faqModule');

if (ifExist('.faq-rating')) import(/* webpackChunkName: "faqRating" */ 'Feature/ContentElements/code/Scripts/Faq/faqRating');

if (ifExist('.news-teaser')) import(/* webpackChunkName: "newsteaser" */ 'Feature/ContentElements/code/Scripts/News/newsteaser');

if (ifExist('.faq-copypage')) import(/* webpackChunkName: "faqCopyPage" */ 'Feature/ContentElements/code/Scripts/Faq/faqCopyPage');

if (ifExist('.need-questions')) import(/* webpackChunkName: "needQuestions" */ 'Feature/ContentElements/code/Scripts/NeedQuestions/needQuestions');

if (ifExist('.gallery-slider')) import(/* webpackChunkName: "gallerySlider" */ 'Feature/ContentElements/code/Scripts/GallerySlider/gallerySlider');

if (ifExist('.metanavloginLayer-collapse')) import(/* webpackChunkName: "loginLayer" */ 'Feature/Navigation/code/Scripts/Navigation/loginLayer');

if (ifExist('.quote-slider-container')) import(/* webpackChunkName: "quoteSlider" */ 'Feature/ContentElements/code/Scripts/QuoteSlider/quoteSlider');

if (ifExist('.algolia-search')) import(/* webpackChunkName: "algoliaSearch" */ '../../../../Feature/ContentElements/code/Scripts/AlgoliaSearch/algoliaSearch');

if (ifExist('#foerderFinderApp')) import(/* webpackChunkName: "foerderfinder.cmp" */ 'Common/Frontend/components/organisms/foerderfinder/foerderfinder.cmp.js');

if (ifExist('.service-teaser-container')) import(/* webpackChunkName: "serviceTeaser" */ 'Feature/ContentElements/code/Scripts/ServiceTeaser/serviceTeaser');

if (ifExist('.chapter-overview-container')) import(/* webpackChunkName: "chapterOverview" */ 'Feature/ContentElements/code/Scripts/ChapterOverview/chapterOverview');

if (ifExist('.overview-page-teaser')) import(/* webpackChunkName: "overviewPageTeaser" */ 'Feature/ContentElements/code/Scripts/OverviewPageTeaser/overviewPageTeaser');

if (ifExist('.inclusion-automat__parts')) import(/* webpackChunkName: "inclusionAutomat" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/inclusionAutomat');

if (ifExist('.videoNumbers-check-container')) import(/* webpackChunkName: "numbersVideoCheck" */ 'Feature/ContentElements/code/Scripts/TeaserNumbersCheck/numbersVideoCheck');

if (ifExist('.content-teaser-block')) import(/* webpackChunkName: "ContentTeaserBlockElement" */ 'Feature/ContentElements/code/Scripts/ContentTeaserBlock/ContentTeaserBlockElement');

if (ifExist('.sponsorship-examples-overview')) import(/* webpackChunkName: "sponsorshipListView" */ 'Feature/SponsorshipExamples/code/Scripts/SponsorshipExamples/sponsorshipListView');

if (ifExist('.contact-database-eutb-form')) import(/* webpackChunkName: "contactDatabaseEutbForm" */ 'Feature/ContentElements/code/Scripts/ContactDatabaseEutbForm/contactDatabaseEutbForm');

if (ifExist('.mobileNavLink,.nav-mobile-meta-template,.nav-mobile')) import(/* webpackChunkName: "mobileNavigation" */ 'Feature/Navigation/code/Scripts/Navigation/mobileNavigation');

if (ifExist('.chapter-overview-infobox-container')) import(/* webpackChunkName: "chapterOverviewInfobox" */ 'Feature/ContentElements/code/Scripts/ChapterOverviewInfobox/chapterOverviewInfobox');

if (ifExist('.chapter-overview-compact-container')) import(/* webpackChunkName: "chapterOverviewCompact" */ 'Feature/ContentElements/code/Scripts/ChapterOverviewCompact/chapterOverviewCompact');

if (ifExist('.personio-jobsad-main')) import(/* webpackChunkName: "personioJobsAdMain" */ 'Feature/Personio/code/Scripts/personioJobsAdMain');

if (ifExist('.personio-back-to-link')) import(/* webpackChunkName: "personioBackToLink" */ 'Feature/Personio/code/Styles/personioBackToLink.scss');

if (ifExist('.personio-jobsad-main')) import(/* webpackChunkName: "personioTracking" */ 'Feature/Personio/code/Scripts/personioTracking');

if (ifExist('.personio-jobsad-stageimage')) import(/* webpackChunkName: "personioStageImage" */ 'Feature/Personio/code/Styles/personioStageImage.scss');

if (ifExist('.personio-jobsad-jobdetail')) import(/* webpackChunkName: "personioJobDetail" */ 'Feature/Personio/code/Styles/personioJobDetail.scss');

if (ifExist('.personio-jobsad-positionsoverview')) import(/* webpackChunkName: "personioPositionsOverview" */ 'Feature/Personio/code/Scripts/personioPositionsOverview');

if (ifExist('.personio-jobsad-benefits')) import(/* webpackChunkName: "personioBenefits" */ 'Feature/Personio/code/Scripts/personioBenefits');

if (ifExist('.personio-jobsad-contactinfo')) import(/* webpackChunkName: "personioContactInfo" */ 'Feature/Personio/code/Styles/personioContactInfo');

if (ifExist('.personio-jobsad-projectslider')) import(/* webpackChunkName: "personioProjectSlider" */ 'Feature/Personio/code/Scripts/personioProjectSlider');

if (ifExist('.personio-jobsad-specificinfo')) import(/* webpackChunkName: "personioSpecificInfo" */ 'Feature/Personio/code/Styles/personioSpecificInfo.scss');

if (ifExist('.personio-jobsad-workwith')) import(/* webpackChunkName: "personioWorkWith" */ 'Feature/Personio/code/Styles/personioWorkWith.scss');

if (ifExist('.personio-jobsad-application-tiles')) import(/* webpackChunkName: "personioApplicationTiles" */ 'Feature/Personio/code/Styles/personioApplicationTiles.scss');

if (ifExist('.search-tile')) import(/* webpackChunkName: "searchBox" */ 'Feature/ContentElements/code/Scripts/Searchbox/searchBox');

if (ifExist('.inyourarea-sponsorshipexamples')) import(/* webpackChunkName: "inyournearSponsorshipExamplesSlider" */ 'Feature/SponsorshipExamples/code/Scripts/SponsorshipExamples/inyournearSponsorshipExamplesSlider');

if (ifExist('.special-lottery-interferer-desktop-template')) import(/* webpackChunkName: "specialLotteryInterferer" */ 'Feature/SpecialLotteryInterferer/code/Scripts/specialLotteryInterferer');

if (ifExist('.nav-simple-language-tile-children-overview')) import(/* webpackChunkName: "simpleLanguageTileChildrenOverview" */ 'Feature/SimpleLanguage/code/Scripts/simpleLanguageTileChildrenOverview.js');

if (ifExist('.simple-language-mobile-sign-in')) import(/* webpackChunkName: "simpleLanguageSignInMetaNavigation" */ 'Feature/SimpleLanguage/code/Scripts/simpleLanguageSignInMetaNavigation.js');

if (ifExist('body.simple-language')) import(/* webpackChunkName: "simpleLanguage" */ 'Feature/SimpleLanguage/code/Styles/simpleLanguage.scss');

if (ifExist('body.simple-language')) import(/* webpackChunkName: "simpleLanguageSearchHeaderNavigation" */ 'Feature/SimpleLanguage/code/Scripts/simpleLanguageSearchHeaderNavigation.js');

if (ifExist('.app-rating-module')) import(/* webpackChunkName: "appRating" */ 'Feature/ContentElements/code/Scripts/AppRating/appRating.js');

if (ifExist('.lottery-stage')) import(/* webpackChunkName: "lotteryStage" */ 'Feature/LotteryContentElements/code/Scripts/LotteryStage/lotteryStage');